import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http:HttpClient) { }


  addMessage(formData:FormData):Observable<any>{
    return this.http.post(environment.Server_URL+'/contact-us',formData);
  }
}
